module.exports = __webpack_public_path__ + "img/img01.4c17640b.png";